import fitty from "fitty";
import React, { useEffect, useRef } from "react";
import { AVATAR_CDN } from "constants/constants";

const EfficeIconLarge = ({ rootName, rootIcon }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      fitty(ref.current, {
        minSize: 16,
        maxSize: 36,
      });
    }
  }, [rootName]);

  const renderedContents = () => {
    if (rootIcon == null) {
      if (rootName.length > 2) {
        return <div ref={ref}>{rootName[0] + rootName[1] + rootName[2]}</div>;
      } else if (rootName.length > 1) {
        return <div ref={ref}>{rootName[0] + rootName[1]}</div>;
      } else if (rootName.length > 0) {
        return <div ref={ref}>{rootName[0]}</div>;
      }
      return <div>{""}</div>;
    } else if (typeof rootIcon === "object") {
      return <img src={URL.createObjectURL(rootIcon)} alt="head effice icon" />;
    } else {
      return <img src={AVATAR_CDN + rootIcon} alt="head effice icon" />;
    }
  };

  return (
    <div className={`effice-icon-large ${rootIcon ? "bg-white" : ""}`}>
      {renderedContents()}
    </div>
  );
};

export default EfficeIconLarge;
